import React from 'react';
import styled, { css } from 'styled-components';

import CheckIcon from '../../svgs/CheckIcon';

export const OptionList = styled.div`
  display: flex;
  gap: 8px;
`;

const OptionItemContainer = styled.div.attrs(
  (props: { isCurrent: boolean; fontSize?: string }) => props,
)`
  padding: 16px;
  position: relative;
  border-radius: 8px;
  box-sizing: border-box;
  border: 1px solid transparent;
  cursor: pointer;
  color: #f3e9d7;
  flex: 1;
  border: 1px solid #484848;
  display: flex;
  align-items: center;
  font-size: ${props => props.fontSize || '12px'};
  font-weight: 700;
  font-family: Inter;
  line-height: 18px;
  user-select: none;
  ${props =>
    props.isCurrent &&
    css`
      border-color: #17c964;
    `}
`;

const CheckIconContainer = styled.div.attrs(
  (props: { isCurrent: boolean }) => props,
)`
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 14px;
  right: 16px;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  background: #484848;
  ${props =>
    props.isCurrent &&
    css`
      background: #4ad067;
    `}
`;

interface OptionItemProps {
  isCurrent: boolean;
  fontSize?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

export function OptionItem({
  isCurrent,
  fontSize,
  children,
  onClick,
}: OptionItemProps) {
  return (
    <OptionItemContainer
      isCurrent={isCurrent}
      fontSize={fontSize}
      onClick={onClick}
    >
      {children}
      <CheckIconContainer isCurrent={isCurrent}>
        <CheckIcon fillColor="#03041a" />
      </CheckIconContainer>
    </OptionItemContainer>
  );
}
